import React from 'react';
import { MagnifyingGlassIcon, MapPinIcon } from '@heroicons/react/24/outline';

interface ExploreHeaderProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onNearbyClick: () => void;
  isNearbyLoading: boolean;
}

const ExploreHeader: React.FC<ExploreHeaderProps> = ({
  searchQuery,
  onSearchChange,
  onNearbyClick,
  isNearbyLoading
}) => {
  return (
    <div className="bg-white dark:bg-gray-900 border-b border-gray-100 dark:border-gray-800 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-1.5 md:py-2">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-2 md:gap-3">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white tracking-tight">Explore Talent</h1>
            <p className="text-xs md:text-sm text-gray-500 dark:text-gray-400 mt-0.5">Discover creators, models, and creatives</p>
          </div>

          <div className="flex items-center gap-3 flex-1 md:max-w-xl justify-end">
            {/* Search Bar */}
            <div className="relative flex-1">
              <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                placeholder="Search by name, skill, or keyword..."
                className="w-full pl-9 pr-4 py-1.5 md:py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-black dark:focus:ring-white focus:border-transparent transition-all outline-none text-sm text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
              />
            </div>

            {/* Nearby Button */}
            <button
              onClick={onNearbyClick}
              disabled={isNearbyLoading}
              className={`flex items-center gap-2 px-3 py-2 rounded-xl border font-medium transition-all text-sm ${
                isNearbyLoading
                  ? 'bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-500 border-gray-200 dark:border-gray-700 cursor-wait'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-200 dark:border-gray-700 hover:border-black dark:hover:border-white hover:text-black dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-700'
              }`}
            >
              <MapPinIcon className={`w-5 h-5 ${isNearbyLoading ? 'animate-pulse' : ''}`} />
              <span className="hidden sm:inline">Nearby</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreHeader;
